export default "__VITE_ASSET__Sn5ujMht__"